import * as Yup from 'yup';
import {
  DimensionClassOptions,
  UnitOfMeasureOptions,
} from 'types/unitsOfMeasure';
import { dimensionFormConstants } from 'utils/unitsOfMeasure/constants';

export const quantFieldSchema = Yup.number().when('$tempUoM', {
  is: true,
  then: (schema) => schema.nullable(),
  otherwise: (schema) =>
    schema
      .required('Quantity is required')
      .min(1, 'Quantity must be at least 1')
      .typeError('Quantity must be a number'),
});

export const dimensionValueSchema = Yup.number().when('$tempUoM', {
  is: true,
  then: (schema) =>
    schema
      .required('Quantity is required')
      .min(1, 'Quantity must be at least 1')
      .typeError('Quantity must be a number'),
  otherwise: (schema) => schema.nullable(),
});

export const dimensionUnitSchema = Yup.mixed<UnitOfMeasureOptions>()
  .oneOf(Object.values(UnitOfMeasureOptions))
  .when('$tempUoM', {
    is: true,
    then: (schema) =>
      schema.required('Unit is required').typeError('Unit is required'),
    otherwise: (schema) => schema.nullable(),
  });

export const dimensionClassSchema = Yup.mixed<DimensionClassOptions>()
  .oneOf(Object.values(DimensionClassOptions))
  .when('$tempUoM', {
    is: true,
    then: (schema) =>
      schema
        .required('Dimension class is required')
        .typeError('Dimension class is required'),
    otherwise: (schema) => schema.nullable(),
  });

export const dimensionSchemas = {
  dimensionValue: dimensionValueSchema,
  dimensionUnit: dimensionUnitSchema,
  dimensionClass: dimensionClassSchema,
} as const;

export const dimensionSchemasMapped = {
  [dimensionFormConstants.dimensionValue.id]: dimensionValueSchema,
  [dimensionFormConstants.dimensionUnit.id]: dimensionUnitSchema,
  [dimensionFormConstants.dimensionClass.id]: dimensionClassSchema,
} as const;
